import gql from 'graphql-tag';

export default gql`
query CheckMyLease(
        $uuid: String!
        ) {
    checkMyLease(
        uuid: $uuid
    ) {
        __typename
        uuids
        type
        created
        expires
        endpointsCompleted
        completed
    }
}
`;
